export default __webpack_public_path__ + "static/media/time_series.76ee5ef5.png";